import React from "react";
import styled from "styled-components";
import Header from "src/core/common/components/collections/menu/simple";
import DeliveryBanner from "src/core/deliveries/components/DeliveryBanner";
import AnnouncementMessage from "@menu/components/AnnouncementMessage";
import useFeatureToggles from "src/core/common/hooks/useFeatureToggles";
import CategoryBar from "@menu/components/CategoryBar";
import dynamic from "next/dynamic";
import {logModuleLoadError} from "src/core/common/utils";
import useBasePage from "src/core/common/hooks/useBasePage";

export default function SenseBasePage({children, ...props}) {
  const {showAnnouncementMessage} = useBasePage();
  const toggles = useFeatureToggles();
  return (
    <>
      <Header isSearchEnabled={true} />
      {!toggles.kioskMode() && <DeliveryBanner />}
      {showAnnouncementMessage && <AnnouncementMessage />}
      <CategoryBar />
      <Content disableMaxWidth={props.disableMaxWidth}>{children}</Content>
      <ProductDetailModal {...props} />
    </>
  );
}

const ProductDetailModal = dynamic(
  () =>
    import("src/core/pages/ProductDetail").catch(
      logModuleLoadError("ProductDetail", {critical: true})
    ),
  {
    ssr: true,
  }
);

const Content = styled.div`
  margin: 0 auto;
  max-width: ${({disableMaxWidth}) => (disableMaxWidth ? "none" : "1440px")};
`;
